import { Briefcase, Route, Users, Smartphone } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal, SectionHead } from "@/components/Reveal";
import { CONCEPT } from "@/data/content";

const ICONS = { briefcase: Briefcase, route: Route, users: Users, smartphone: Smartphone };

export default function Concept() {
  return (
    <section id="concept" className="relative overflow-hidden py-16 md:py-24 lg:py-32" data-testid="concept-section">
      <div
        className="pointer-events-none absolute -top-40 right-0 h-[500px] w-[500px] rounded-full opacity-60"
        style={{ background: "radial-gradient(circle, rgba(212,175,55,0.08) 0%, transparent 65%)" }}
        aria-hidden="true"
      />
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHead
          eyebrow="Le concept"
          title="Quatre piliers. Un seul club."
          sub="MBC84 réunit ce qui fait avancer les entrepreneurs : le réseau, la moto, les rencontres et une communauté soudée."
        />

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6" data-testid="concept-grid">
          {CONCEPT.map((c, i) => {
            const Icon = ICONS[c.icon];
            return (
              <Reveal key={c.title} delay={i * 0.08}>
                <motion.div
                  whileHover={{ y: -8 }}
                  transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                  className="group relative h-full overflow-hidden rounded-2xl border border-border bg-card p-7 transition-colors duration-300 hover:border-gold/50"
                  data-testid={`concept-card-${c.title.toLowerCase()}`}
                >
                  <span className="pointer-events-none absolute -right-5 -top-6 font-heading text-[6rem] font-extrabold leading-none text-foreground/[0.04] transition-colors duration-300 group-hover:text-gold/10">
                    0{i + 1}
                  </span>
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl border border-gold/30 bg-gold/10 text-gold transition-all duration-300 group-hover:scale-110 group-hover:bg-gold group-hover:text-night">
                    <Icon className="h-5 w-5" strokeWidth={1.8} />
                  </span>
                  <h3 className="mt-6 font-heading text-xl font-bold uppercase tracking-wide text-foreground">{c.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{c.text}</p>
                  <span className="mt-6 block h-px w-10 bg-gold/40 transition-all duration-500 group-hover:w-full group-hover:bg-gold/70" />
                </motion.div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.1} className="mt-16 md:mt-20">
          <div className="relative mx-auto max-w-4xl text-center" data-testid="concept-quote">
            <span className="pointer-events-none absolute -top-10 left-1/2 -translate-x-1/2 font-serif text-[7rem] leading-none text-gold/15" aria-hidden="true">
              "
            </span>
            <p className="font-serif text-2xl italic leading-snug text-foreground sm:text-3xl lg:text-4xl">
              Ici, on ne se contente pas de rouler ensemble.{" "}
              <span className="text-gold-grad not-italic font-heading font-bold">On avance ensemble.</span>
            </p>
            <div className="hairline mx-auto mt-8 w-40" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
